import { baseApi, RTKQueryTag } from '../../../data/baseApi'

export type CareTimelineSessionProvider = {
  id: string | null
  name: string
  displayName: string
  imageUrl: string | null
  rectangularImageUrl: string | null
  portraitImageUrl: string | null
}

export type CareTimelineSession = {
  appointmentId: string
  startDateTime: string
  timeZone: string
  duration: number
  appointmentStatus: string
  sessionNumber: number | null
  appointmentType: string
  sessionType: string | null
  suggestedSessionType?: string | null
  meetingFormat: string
  childFirstName: string | null
  guardianFirstName: string | null
  episodeId: string
  programId: string | null
  programName: string | null
  changeReason?: string | null
  childLyraId?: string | null
  guardianLyraId?: string | null
  cancelledByLyraId?: string | null
  provider: CareTimelineSessionProvider
}

type GetCareTimelineSessionsArgs = {
  patientId: string
}

const careTimelineApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCareTimelineSessions: builder.query<CareTimelineSession[], GetCareTimelineSessionsArgs>({
      query: ({ patientId }) => ({
        method: 'get',
        url: `/lt/v1/patient/${patientId}/care-history/sessions`,
      }),
      providesTags: [RTKQueryTag.APPOINTMENT],
    }),
  }),
})

export const { useGetCareTimelineSessionsQuery } = careTimelineApi
export default careTimelineApi
